import React, {useEffect, useState} from 'react';
import {callEmptyParamsApi} from "../../../connection/ClientApi";
import Space from "components/space/Space";
import IconTitleValue from "components/textValue/IconTitleValue";
import MapComponent from "components/map/MapComponent";
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import {Divider} from "@material-ui/core";

import ICAboutUsMobile from "res/images/about_us_mobile.png";
import ICAboutUsDesktop from "res/images/about_us_desktop.png";
import ICPhone from "res/images/phone.png";
import ICMail from "res/images/message.png";
import ICAddress from "res/images/address.png";
import LeafletMapComponent from "components/map/LeafletMapComponent";

export default function ContactUs(props) {

    const [aboutUs, setAboutUs] = useState()

    function requestGetAboutUs() {
        callEmptyParamsApi(Urls.getAboutUs, (data) => {
                setAboutUs(data.list)
            }, () => {
                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            }
        )
    }

    function title() {
        return <div className="marginLeftRightMedium">
            <div className="largeTextBold">
                {messages.connectWithUs}
            </div>
            <Space height={"1em"}/>
            <Divider/>
            <Space height={"1.5em"}/>
        </div>
    }

    useEffect(() => {
        requestGetAboutUs()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<>
        {(aboutUs && aboutUs.about_us) &&
        <div className="hInLP_vInTFMS fullWidth">
            <div className="marginTopBottomMedium hideInLP_showInTFMS" style={{float: "left"}}>
                <img className="fullWidth" src={ICAboutUsMobile} alt={"صرفه مارکت"}/>
            </div>
            <div className="marginTopBottomMedium wInP50_wInTFM100">
                {title()}
                <div className="largeText marginLeftRightMedium">
                    {aboutUs.about_us.split(".")[0] + "."}
                </div>
                <Space height={"2em"}/>
                <div className="marginTopMedium">
                    <div className="marginLeftRightMedium">
                        <IconTitleValue
                            icon={<img src={ICPhone} alt="" className="xxSmallIcon"/>}
                            title={messages.connectWithUsPhone}
                            titleClassName={"mediumText"}
                            value={aboutUs.telephone}
                            valueClassName={"mediumTextBold"}/>
                        <Divider/>
                        <IconTitleValue
                            icon={<img src={ICMail} alt="" className="xxSmallIcon"/>}
                            title={messages.connectWithUsEmail}
                            titleClassName={"mediumText"}
                            value={messages.sarfeMarketEmail}
                            valueClassName={"blueColor mediumTextBold"}/>
                        <Divider/>
                        <IconTitleValue
                            icon={<img src={ICAddress} alt="" className="xxSmallIcon"/>}
                            title={messages.connectWithUsAddress}
                            titleClassName={"mediumText"}
                            value={messages.sarfeMarketAddress}
                            valueClassName={"mediumTextBold"}/>
                    </div>
                    <div className="shadow wInLP100_wInTFMS95 marginLeftRightMedium marginTopMedium"
                         style={{height: "20em"}}>
                        <LeafletMapComponent
                            isStatic={true}
                            isFirstLode={true}
                            center={{
                                latitude: parseFloat(35.695345),
                                longitude: parseFloat(51.346095),
                            }}
                            markers={[{
                                latitude: parseFloat(35.695345),
                                longitude: parseFloat(51.346095),
                                icon: "https://sarfe.bpc.ir/image/catalog/Standard%20Banner/home.png"
                            }]}/>
                    </div>
                </div>
            </div>
            <div className="marginTopBottomMedium halfWidth showInLP_hideInTFMS" style={{float: "left"}}>
                <img className="fullWidth" src={ICAboutUsDesktop} alt={"صرفه مارکت"}/>
            </div>
        </div>
        }
    </>)
}